import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from "src/store/hooks";

import {Button as ButtonAnt, Image, message, Space } from "antd";
import { ImageInterface, selectAllImages, setEditId } from "src/store/community/imagesSlice";
import { ColumnsType } from "antd/es/table";
import Table from "src/componets/Table";
import { formattedDate } from "src/helpers/DateHelpers";
import { ButtonDestroy, ButtonEdit } from "src/componets/Buttons";
import { EntityId } from "@reduxjs/toolkit";
import { destroyImage, groupDestroyImage } from "src/actions/community/imagesActions";
import { DeleteOutlined } from '@ant-design/icons';
import usePermissions from "src/hooks/usePermissions";

interface ListTableInterface {
  className?: string;
}

const _ListTable = ({ className }: ListTableInterface) => {
  const dispatch = useAppDispatch();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const images = useAppSelector(selectAllImages);
  const { write_community } = usePermissions();
  const hasSelected = selectedRowKeys.length > 0;
  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys
  };

  function onClickGroupDestroy() {
    handleGroupDestroy().catch(console.error);
  }

  async function handleGroupDestroy () {
    const resultAction = await dispatch(groupDestroyImage(selectedRowKeys));

    if (groupDestroyImage.fulfilled.match(resultAction)) {
      setSelectedRowKeys([]);
      message.success(`Items ${selectedRowKeys.join(', ')} was successful deleted`);
    }

    if (groupDestroyImage.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyImage(id));

    if (destroyImage.fulfilled.match(resultAction)) {
      const filtered = selectedRowKeys.filter(key => key !== id);

      setSelectedRowKeys([...filtered]);
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyImage.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  const columns: ColumnsType<ImageInterface> = [
    {
      key: 'file_url',
      title: 'Image',
      dataIndex: 'file_url',
      render: (_, { file_url }) => {
        return <Image src={file_url} width={44} />
      },
      width: 70
    },

    {
      key: 'created_at',
      title: 'Created at',
      render: (_, { created_at }) => {
        return <small>{formattedDate(created_at).dateTime}</small>;
      },
      width: 125
    },

    {
      key: 'updated',
      title: 'Updated at',
      render: (_, { updated_at }) => {
        return <small>{formattedDate(updated_at).dateTime}</small>;
      },
      width: 125
    },

    ...(write_community ? [{
      key: 'action',
      title: 'Action',
      render: (_: any, { id }: ImageInterface) => {
        return (
          <Space size="middle">
            <ButtonEdit key={'button-edit'} onClick={() => onClickEdit(id)} />
            <ButtonDestroy key='button-destroy' onClick={() => onClickDestroy(id)} />
          </Space>
        );
      },
      width: 250
    }] : []),
  ];

  return (
    <div className={className}>
      {
        write_community &&
          <div className='v-mb-10'>
            <ButtonAnt
              danger
              type="primary"
              onClick={onClickGroupDestroy}
              disabled={!hasSelected}
              className='v-mr-10'
              size='small'
              icon={<DeleteOutlined />}
            >
              Destroy
            </ButtonAnt>

            <span style={{ marginLeft: 8 }}>
              {hasSelected ? `Selected ${selectedRowKeys.length} images` : ''}
            </span>
          </div>
      }

      <Image.PreviewGroup>
        <Table
          rowKey='id'
          rowSelection={write_community ? rowSelection : undefined}
          columns={columns}
          dataSource={images}
        />
      </Image.PreviewGroup>
    </div>
  );
}

export default _ListTable;
